import { Container, Tabs } from '@itds/elements/index.js';
import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';

import { ACTION_MESSAGES } from '@brokerage/utils/custom_hooks/useNotification';
import { Api } from '@brokerage/utils/Api';
import Build from './Build';
import BuildAssets from './BuildAssets';
import BuildCredentials from './BuildCredentials';
import Builds from './Builds';
import H1 from '@brokerage/components/H1';
import { MobileAppContext } from '@brokerage/contexts/MobileAppContext';
import Notification from '@brokerage/components/Notification';
import { useNotification } from '@brokerage/utils/custom_hooks/useNotification';

const MobileAppsShow = () => {
  const params = useParams();

  const [builds, setBuilds] = useState([]);
  const [headers, setHeaders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mobile_app, setMobileApp] = useState(null);
  const [page, setPage] = useState(1);
  const { notification, setNotification } = useNotification({ type: null, message: '' });

  useEffect(() => {
    loadApp();
  }, []);

  useEffect(() => {
    loadBuilds();
    window.scrollTo(0, 0);
  }, [page]);

  const loadApp = () => {
    setLoading(true);
    Api.loadApp(params.guid).then(response => {
      const { data } = response;

      setMobileApp(data);
      setLoading(false);
    });
  };

  const loadBuilds = () => {
    setLoading(true);
    Api.loadBuilds(params.guid, page).then(response => {
      let { headers } = response;
      const { data } = response;

      headers = JSON.parse(headers['x-pagination']);
      setBuilds(data);
      setHeaders(headers);
      setLoading(false);
    });
  };

  const updateMobileApp = payload => {
    setLoading(true);
    Api.updateMobileApp(params.guid, payload)
      .then(response => {
        const { data, status } = response;

        if (status === 200) {
          setMobileApp(data);
          context.setNotification(ACTION_MESSAGES.MOBILE_APPS.UPDATE);
        }
        window.scrollTo(0, 0);
        setLoading(false);
      })
      .catch(error => {
        if (error) {
          setLoading(false);
          context.setNotification(ACTION_MESSAGES.MOBILE_APPS.UPDATE_ERROR);
        }
      });
  };

  const child_props = {
    updateMobileApp,
    loadApp,
    loadBuilds,
    builds,
    headers,
    loading,
    mobile_app,
    page,
    params,
    setPage
  };

  const context = {
    notification,
    setNotification
  };

  return mobile_app ? (
    <MobileAppContext.Provider value={context}>
      <Container>
        <Notification {...context.notification} />

        <H1>{mobile_app.name}</H1>
        <Tabs
          tabs={[
            {
              isActive: window.location.hash.includes('builds'),
              label: 'Builds',
              to: 'builds'
            },
            {
              isActive: window.location.hash.includes('build_credentials'),
              label: 'Build Credentials',
              to: 'build_credentials'
            },
            {
              isActive: window.location.hash.includes('build_assets'),
              label: 'Build Assets',
              to: 'build_assets'
            }
          ]}
        />

        <div style={{ paddingTop: 30 }}>
          <Routes>
            <Route element={<BuildAssets {...child_props} />} path='build_assets' />
            <Route element={<Builds {...child_props} />} path='builds/*' />
            <Route element={<Build {...child_props} />} path='builds/:build_guid' />
            <Route element={<BuildCredentials {...child_props} />} path='build_credentials' />
          </Routes>
        </div>
      </Container>
    </MobileAppContext.Provider>
  ) : null;
};

export default MobileAppsShow;
